export default __webpack_public_path__ + "static/media/quienesSomos.9b2d9c18.jpg";